let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1z7dS")).then(() => parcelRequire('hPwRJ'));